var exports = {
  "n": "skeletonContainer__TriVfL",
};

module.exports = exports;
